import React from "react";
import { Zap, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLang } from "@/i18n";

/** Meterstand invoeren bij een tussentijdse of definitieve afrekening. */
export default function MeterField({ meterStart, value, onChange, onRecalc, lastKnown }) {
  const { t } = useLang();
  const used = value === "" || meterStart == null ? null : Math.round((Number(value) - Number(meterStart)) * 10) / 10;
  return (
    <div className="rounded-lg border border-border bg-secondary/30 px-3 py-2 space-y-1" data-testid="meter-field">
      <div className="flex items-end gap-2">
        <div className="space-y-1">
          <Label className="text-xs flex items-center gap-1"><Zap className="h-3.5 w-3.5" />{t("meter_now")}</Label>
          <Input type="number" min="0" step="0.1" className="w-36" value={value}
            onChange={(e) => onChange(e.target.value)} data-testid="meter-now-input" />
        </div>
        <Button variant="outline" size="sm" onClick={onRecalc} data-testid="meter-recalc">
          <RefreshCw className="h-4 w-4 mr-1" />{t("meter_recalc")}
        </Button>
        {lastKnown != null && value === "" && (
          <button type="button" className="text-[11px] text-primary underline pb-2" data-testid="meter-use-last"
            onClick={() => onChange(lastKnown)}>{t("meter_last_known")}: {lastKnown} kWh</button>
        )}
      </div>
      <p className="text-[11px] text-muted-foreground" data-testid="meter-info">
        {t("meter_start_label")}: {meterStart == null ? t("meter_last_unknown") : `${meterStart} kWh`}
        {used != null && used >= 0 && ` · ${t("meter_consumption")}: ${used} kWh`}
      </p>
    </div>
  );
}
